import { Select } from "antd"
import { DeleteIcon } from "components/ui/icons/userActions/DeleteIcon"
import type { ICategoriesData } from "types/configuration.type"
import style from "./SelectCombination.module.scss"
import { Tooltip } from "components/ui/tooltip/Tooltip"

const { selectCombination, select } = style

type Props = {
	categories: ICategoriesData
	deleteColumnHandle: () => void
	value?: string
	onChange?: (option: { label: string; value: string }) => void
}

export const SelectCombination = ({ categories, deleteColumnHandle, onChange, value }: Props) => {
	// Helper function to extract all category objects and create options
	const getCategoryOptions = () => {
		const options: { label: string; value: string }[] = []

		// Iterate through all top level categories
		for (const topLevelCategory of Object.values(categories)) {
			// Iterate through all supercategories
			for (const categoryObjects of Object.values(topLevelCategory)) {
				// Add each category object to options
				for (const categoryObj of categoryObjects) {
					if (!categoryObj.category) {
						continue
					}
					options.push({
						label: categoryObj.category,
						value: categoryObj.id.toString(),
					})
				}
			}
		}

		return options
	}

	return (
		<div className={selectCombination}>
			<Select
				value={value}
				onChange={(_, option) => {
					if (onChange && option && !Array.isArray(option)) {
						onChange(option as { label: string; value: string })
					}
				}}
				className={select}
				options={getCategoryOptions()}
			/>
			<Tooltip text="Delete dropdown" placement="bottom">
				<button onClick={deleteColumnHandle} type="button">
					<DeleteIcon variant="black" />
				</button>
			</Tooltip>
		</div>
	)
}
